import { CategoryPathProps } from '~types/index'

const parseForHybrid = ({ slug, redirectTo, reference }: CategoryPathProps) =>
  `/ca/${redirectTo || slug || reference}`
export default parseForHybrid // TODO: replace this with a navigation to categories
